import React, { useEffect, useContext } from 'react';
import mixpanel, { Dict } from 'mixpanel-browser';

interface IContext {
  trackEvent: (eventName: string, properties: Dict) => void;
  identify: (identifier: string) => void;
  setPeople: (field: string, value: string) => void;
}

interface IProvider {
  children: React.ReactElement;
}

const AnalyticsContext = React.createContext<IContext>({} as IContext);

export function useAnalytics(): IContext {
  return useContext(AnalyticsContext);
}

export function AnalyticsProvider({ children }: IProvider): React.ReactElement {
  const isEnabled = Boolean(process.env.REACT_APP_MIXPANEL_TOKEN);

  function trackEvent(eventName: string, properties: Dict): void {
    if (!isEnabled) return;
    mixpanel.track(eventName, properties);
  }
  function identify(identifier: string): void {
    if (!isEnabled) return;
    mixpanel.identify(identifier);
  }
  function setPeople(field: string, value: string): void {
    if (!isEnabled) return;
    mixpanel.people.set(field, value);
  }

  useEffect(() => {
    if (isEnabled) {
      mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN as string);
    }
  }, []);

  const value = {
    identify,
    setPeople,
    trackEvent,
  };

  return <AnalyticsContext.Provider value={value}>{children}</AnalyticsContext.Provider>;
}
